import { createAction, props } from "@ngrx/store";
import { EmployeeProfile } from "../../widgets/staar/models/employee-profile";

export const setEmployee = createAction(
  '[Users] Set Employee',
  props<{ employee: EmployeeProfile}>()
)

export const setCustomerEmployeeVNumber = createAction(
  '[Users] Set CustomerEmployeeVNumber',
  props<{ vNumber: string}>()
)
